function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding-bottom: 4rem;\n  \n  @media (min-width: 768px) {\n    padding-bottom: 0;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5rem 0;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 2rem;\n  width: 2rem;\n  animation: spin 1s linear infinite;\n  color: ",
        ";\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  padding: 1rem;\n  margin: 1rem;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  border-radius: 0.375rem;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  height: 1.25rem;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  padding: 1rem;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.3s;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.75rem 1rem;\n  background-color: var(--theme-primary);\n  color: var(--theme-primary-text);\n  \n  &:hover {\n    background-color: var(--theme-primary-dark);\n  }\n  \n  &:active {\n    transform: scale(0.98);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import { project_emptyMessage, loading_projects, error_occurred, loadMore } from '@paraglide/messages';
// Fixed import to use main lucide-react package to resolve TDZ initialization issues
import { Loader2, AlertCircle as AlertTriangle, Star } from 'lucide-react';
import { TabNav } from '@edusense/shared-ui-layout';
import { ProjectListSection } from '../ProjectListSection';
import styled from '@emotion/styled';
import { StatusDisplay } from "@edusense/shared-ui-kit";
// Styled Components
var Container = styled.div(_templateObject(), function(props) {
    return props.className && props.className;
});
var LoadingContainer = styled.div(_templateObject1());
var LoadingIconWrapper = styled.div(_templateObject2(), function(props) {
    return props.theme.primary;
});
var LoadingIcon = function() {
    return /*#__PURE__*/ React.createElement(LoadingIconWrapper, null, /*#__PURE__*/ React.createElement(Loader2, {
        style: {
            width: '100%',
            height: '100%'
        }
    }));
};
var ErrorContainer = styled.div(_templateObject3(), function(props) {
    return props.theme.isDark ? 'rgba(239, 68, 68, 0.2)' : 'rgba(239, 68, 68, 0.1)';
}, function(props) {
    return props.theme.error;
}, function(props) {
    return props.theme.error;
});
var ErrorIconWrapper = styled.div(_templateObject4());
var ErrorIcon = function() {
    return /*#__PURE__*/ React.createElement(ErrorIconWrapper, null, /*#__PURE__*/ React.createElement(AlertTriangle, {
        style: {
            width: '100%',
            height: '100%'
        }
    }));
};
var FooterContainer = styled.div(_templateObject5());
var LoadMoreButton = styled.button(_templateObject6());
/**
 * DiscoverTemplate 컴포넌트 - 발견 페이지의 레이아웃을 구성합니다.
 * 
 * 아토믹 디자인의 템플릿(Template) 레벨 컴포넌트
 */ var DiscoverTemplate = function(param) {
    var projects = param.projects, isLoading = param.isLoading, error = param.error, activeTab = param.activeTab, onTabChange = param.onTabChange, onViewDetails = param.onViewDetails, onLike = param.onLike, onComment = param.onComment, onLoadMore = param.onLoadMore, hasMoreProjects = param.hasMoreProjects, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    // 빈 메시지는 탭에 따라 다르게 설정 가능 (필요시)
    var emptyMessage = project_emptyMessage();
    // 로딩 중일 때 표시할 컴포넌트
    var renderLoading = function() {
        return /*#__PURE__*/ React.createElement(StatusDisplay, {
            type: "loading",
            message: loading_projects()
        });
    };
    // 에러 발생 시 표시할 컴포넌트
    var renderError = function() {
        return /*#__PURE__*/ React.createElement(StatusDisplay, {
            type: "error",
            message: error_occurred({
                error: error || ''
            })
        });
    };
    // 프로젝트 피드 및 푸터를 렌더링하는 함수
    var renderContent = function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ProjectListSection, {
            projects: projects,
            onView: onViewDetails,
            emptyMessage: emptyMessage,
            className: "px-4"
        }), projects.length > 0 && /*#__PURE__*/ React.createElement(FooterContainer, null, hasMoreProjects && /*#__PURE__*/ React.createElement(LoadMoreButton, {
            onClick: onLoadMore
        }, loadMore())));
    };
    return /*#__PURE__*/ React.createElement(Container, {
        className: className
    }, /*#__PURE__*/ React.createElement(TabNav, {
        activeTabId: activeTab,
        onTabChange: onTabChange,
        tabs: [
            {
                id: 'recommended',
                label: '추천',
                icon: /*#__PURE__*/ React.createElement(Star, null)
            },
            {
                id: 'following',
                label: '팔로우 중'
            }
        ]
    }), isLoading ? renderLoading() : error ? renderError() : projects.length === 0 ? /*#__PURE__*/ React.createElement(StatusDisplay, {
        type: "empty",
        message: emptyMessage
    }) : renderContent());
};
export default DiscoverTemplate;
